import { Injectable } from '@angular/core';
import { UserUI } from '@src/models';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class UsersByOrganisationStoreService extends BaseStoreService<UserUI[]> {}
